module.exports = __webpack_public_path__ + "img/sud-ouest.png";